import { makeStyles } from 'tss-react/mui'
import { Property } from 'csstype'

export const useStyles = makeStyles()(theme => ({
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  noteText: {
    fontSize: theme.spacing(1.75),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.25px',
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  summaryCard: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    background: theme.palette.background.paper as Property.Background,
    boxSizing: 'border-box',
  },
  iconWrap: {
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
    borderRadius: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: theme.spacing(0),
    color: theme.palette.text.primary,
  },
  summaryRow: {
    color: theme.palette.text.primary,
    fontSize: theme.spacing(1.75),
    lineHeight: theme.spacing(2.5),
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  editButton: {
    background: theme.palette.action.selected,
    border: 'none',
    cursor: 'pointer',
    color: theme.palette.text.primary,
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
    borderRadius: theme.spacing(1),
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    flexShrink: theme.spacing(0),
  },
  resetRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1.5),
  },
  datePickerErrorOutline: {
    '& [role="group"]': {
      height: theme.spacing(5),
    },
    '& label': { top: 0 },
    '& .MuiPickersOutlinedInput-root': {
      backgroundColor: theme.palette.background.paper,
    },
    '& .MuiPickersOutlinedInput-root:hover': {
      backgroundColor: theme.palette.background.paper,
    },
    '& .MuiPickersOutlinedInput-root.Mui-focused': {
      backgroundColor: theme.palette.background.paper,
    },
    '& .MuiPickersOutlinedInput-root.Mui-error .MuiPickersOutlinedInput-notchedOutline':
      {
        border: `2px solid ${theme.palette.labraV2Errors.main} `,
      },
    '& .MuiPickersOutlinedInput-root.Mui-error:hover .MuiPickersOutlinedInput-notchedOutline':
      {
        border: `2px solid ${theme.palette.labraV2Errors.main} `,
      },
    '& .MuiPickersOutlinedInput-root.Mui-error.Mui-focused .MuiPickersOutlinedInput-notchedOutline':
      {
        border: `2px solid ${theme.palette.labraV2Errors.main} `,
      },
    '& .MuiFormHelperText-root.Mui-error': {
      paddingLeft: theme.spacing(2),
    },
  },
  '@keyframes clonePurchaseDateBlink': {
    '0%, 100%': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
    '50%': {
      backgroundColor: theme.palette.action.selected,
      boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
    },
  },
  cloneDateBlink: {
    animation: '$clonePurchaseDateBlink 0.8s ease-in-out 3',
    borderRadius: theme.spacing(0.5),
  },
}))
